// utils
import anime from 'animejs'
import {
  createAnimation
} from '@/assets/js/utils/createAnimation'
import {
  characterWalk
} from '@/assets/js/utils/characterWalk'
import {
  createRotateAnimation
} from '@/assets/js/utils/createRotateAnimation'
import {
  createWalkAnimation
} from '@/assets/js/utils/createWalkAnimation'

// todo: wave and raise arm

const skylarAnimations = () => {
  return {
    raiseRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#skylar_right_arm",
            rotate: "20deg",
            easing: 'linear',
            duration: 350,
            begin: options.begin,
          })
          .add({
            targets: "#skylar_right_arm_hand",
            rotate: "85deg",
            easing: 'linear',
            duration: 350,
            complete: options.complete
          })
      }, options, this)()
    },
    wave(options) {
      return createAnimation((tl, options) => {
        this.raiseRightArm({
          begin: options.begin,
          complete: () => {
            tl
              .add({
                targets: "#skylar_right_arm_hand",
                rotate: "105deg",
                easing: 'linear',
                duration: 350
              })
              .add({
                targets: "#skylar_right_arm_hand",
                rotate: "95deg",
                easing: 'linear',
                duration: 350
              })
              .add({
                targets: "#skylar_right_arm_hand",
                rotate: "105deg",
                easing: 'linear',
                duration: 350
              })
              .add({
                targets: "#skylar_right_arm_hand",
                rotate: "95deg",
                easing: 'linear',
                duration: 350,
                complete: options.complete
              })
          }
        })
      }, options, this)()
    },
    lowerRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#skylar_right_arm_hand",
            rotate: "0deg",
            easing: 'linear',
            duration: 350,
            begin: options.begin,
          })
          .add({
            targets: "#skylar_right_arm",
            rotate: "0deg",
            easing: 'linear',
            duration: 350,
            complete: options.complete
          })
      }, options, this)()
    },
    walk(options) {
      return createAnimation(createWalkAnimation('#skylar'), options, this)()
    },
    headRotate(options) {
      return createAnimation((tl, options) => {
        options.flipped = options.flipped || false
        tl
          .add({
            targets: "#skylar_head",
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1,
              begin: options.begin,
              complete: options.complete
            },
          })
      }, options, this)()
    }
  }
}

export {
  skylarAnimations
}



// WEBPACK FOOTER //
// ./src/components/module_6/js/skylarAnimations.js